function selectWebConfig() {
  const devKey = "6caf698c-9099-46a8-b49e-208c2c57dde2";
  const prodKey = "9273c5f1-20d5-4c67-9739-7b86fff40162";

  const propmixProd = {
    accessToken: "79e5cddbb7bddc3e0525790d750bf37acb08f874a1d78acbda3811776d947509",
    getUserAccessTokenUrl: "https://sso.propmix.io/getUserAccessToken",
    mcaWebsiteUrl: "https://mca.propmix.io",
  };
  const propmixTest = propmixProd; // same for both

  // Api key is from googlemaps@mueller-inc.com account
  const GOOGLE_MAPS_API_KEY_LOCALHOST = "AIzaSyDxmMvqw8dN7_AntmH5hoajuxdGHCmXKw4"; // Dev key for localhost only
  const GOOGLE_MAPS_API_KEY = "AIzaSyCUXLvdfg-sqLtjQ7TsqRUeyHhN5kbexmk"; // Prod/test key

  const appInsightsOptionsProd = {
    instrumentationKey: prodKey,
    enableDebug: false,
    disableExceptionTracking: false,
    disableAjaxTracking: false,
    maxAjaxCallsPerView: 10, // default is 500
    overridePageViewDuration: false,
  };
  const appInsightsOptionsDev = {
    instrumentationKey: devKey,
    enableDebug: false,
    disableExceptionTracking: false,
    disableAjaxTracking: false,
    maxAjaxCallsPerView: 10, // default is 500
    overridePageViewDuration: false,
  };

  const env = process.env.NODE_ENV;

  switch (env) {
    case "testing":
      return {
        environment: env,
        versionURL: "https://test.mueller-inc.com/webui/version.json",
        orthosRoot: "https://test.mueller-inc.com",
        webApiRoot: "https://test-webapi.mueller-inc.com",
        caseUrlTemplate: "https://test.mueller-inc.com/inspectorappviewpolicy.asp?ControlIDNumber=",
        mapPinRoot: "https://test.mueller-inc.com/images/AssignmentTool/Pins/",
        mapIconPinRoot: "https://test.mueller-inc.com/images/AssignmentTool/icons/",
        appInsightsOptions: appInsightsOptionsDev,
        rootStylesheet: "./environment/non-prod-styles.scss",
        propmix: propmixTest,
        phoenixWorkflowUrl: "https://test-phoenixworkflow.mueller-inc.com",
        photosUrl: "https://test-photos.mueller-inc.com",
        photoService: "https://test-photos.mueller-inc.com/svc",
        photoServiceRoot: "https://test-photos.mueller-inc.com/svc/Accounts",
        photoServiceRootDelete: "https://test-photos.mueller-inc.com/svc/CaseDeleted",
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        signalrConnectionRoot: "https://test-webapi.mueller-inc.com/signalr",
        autoTimeoutDisabled: false,
        hubRoot: "https://test-hub.mueller-inc.com",
        ssoTokenName: "SSO",
        phoenixUrl: "https://test.phoenixsuite.com",
        phoenixAnywhereUrl: "https://testanywhere.phoenixsuite.com",
      };

    case "staging":
      return {
        environment: env,
        versionURL: "https://staging.mueller-inc.com/webui/version.json",
        orthosRoot: "https://staging.mueller-inc.com",
        webApiRoot: "https://staging-webapi.mueller-inc.com",
        caseUrlTemplate: "https://staging.mueller-inc.com/inspectorappviewpolicy.asp?ControlIDNumber=",
        mapPinRoot: "https://test.mueller-inc.com/images/AssignmentTool/Pins/",
        mapIconPinRoot: "https://test.mueller-inc.com/images/AssignmentTool/icons/",
        appInsightsOptions: appInsightsOptionsDev,
        rootStylesheet: "./environment/non-prod-styles.scss",
        propmix: propmixTest,
        phoenixWorkflowUrl: "https://staging-phoenixworkflow.mueller-inc.com",
        photosUrl: "https://staging-photos.mueller-inc.com",
        photoService: "https://staging-photos.mueller-inc.com/svc",
        photoServiceRoot: "https://staging-photos.mueller-inc.com/svc/Accounts",
        photoServiceRootDelete: "https://staging-photos.mueller-inc.com/svc/CaseDeleted",
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        signalrConnectionRoot: "https://staging-webapi.mueller-inc.com/signalr",
        autoTimeoutDisabled: false,
        hubRoot: "https://staging-hub.mueller-inc.com",
        ssoTokenName: "SSO",
        phoenixUrl: "https://www.phoenixsuite.com",
        phoenixAnywhereUrl: "https://anywhere.phoenixsuite.com",
      };

    case "production":
      return {
        environment: env,
        versionURL: "https://www.mueller-inc.com/webui/version.json",
        orthosRoot: "https://www.mueller-inc.com",
        webApiRoot: "https://webapi.mueller-inc.com",
        caseUrlTemplate: "https://www.mueller-inc.com/inspectorappviewpolicy.asp?ControlIDNumber=",
        mapPinRoot: "https://www.mueller-inc.com/images/AssignmentTool/Pins/",
        mapIconPinRoot: "https://www.mueller-inc.com/images/AssignmentTool/icons/",
        appInsightsOptions: appInsightsOptionsProd,
        rootStylesheet: null,
        propmix: propmixProd,
        phoenixWorkflowUrl: "https://phoenixworkflow.mueller-inc.com",
        photosUrl: "https://photos.mueller-inc.com",
        photoService: "https://photos.mueller-inc.com/svc",
        photoServiceRoot: "https://photos.mueller-inc.com/svc/Accounts",
        photoServiceRootDelete: "https://photos.mueller-inc.com/svc/CaseDeleted",
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        signalrConnectionRoot: "https://webapi.mueller-inc.com/signalr",
        autoTimeoutDisabled: false,
        hubRoot: "https://hub.mueller-inc.com",
        ssoTokenName: "SSO",
        phoenixUrl: "https://www.phoenixsuite.com",
        phoenixAnywhereUrl: "https://anywhere.phoenixsuite.com",
      };

    case "development": // fall thru
    default:
      return {
        environment: env,
        versionURL: "http://localhost:4000/version.json",
        orthosRoot: "https://dev.mueller-inc.com",
        webApiRoot: "https://dev-webapi.mueller-inc.com",
        caseUrlTemplate: "https://dev.mueller-inc.com/inspectorappviewpolicy.asp?ControlIDNumber=",
        mapPinRoot: "https://test.mueller-inc.com/images/AssignmentTool/Pins/",
        mapIconPinRoot: "https://test.mueller-inc.com/images/AssignmentTool/icons/",
        appInsightsOptions: appInsightsOptionsDev,
        rootStylesheet: "./environment/non-prod-styles.scss",
        propmix: propmixTest,
        phoenixWorkflowUrl: "https://dev-phoenixworkflow.mueller-inc.com",
        photosUrl: "https://dev-photos.mueller-inc.com",
        photoService: "https://dev-photos.mueller-inc.com/svc",
        photoServiceRoot: "https://dev-photos.mueller-inc.com/svc/Accounts",
        photoServiceRootDelete: "https://dev-photos.mueller-inc.com/svc/CaseDeleted",
        googleMapsApiKey: GOOGLE_MAPS_API_KEY_LOCALHOST,
        signalrConnectionRoot: "https://dev-webapi.mueller-inc.com/signalr",
        autoTimeoutDisabled: false, // Set this to true to turn off the automatic logout
        hubRoot: "https://dev-hub.mueller-inc.com",
        ssoTokenName: "SSO",
        phoenixUrl: "https://test.phoenixsuite.com",
        phoenixAnywhereUrl: "https://testanywhere.phoenixsuite.com",
      };
  }
}

const WebConfig = selectWebConfig();

export default WebConfig;
